import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function BaggageMDisabledFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M11.76 10.44H10.83V3.34H13.13V9.08L14.67 7.54V3.34H14.86C15.34 3.34 15.63 3.05 15.63 2.57C15.63 2.09 15.25 1.8 14.86 1.8H9.10002C8.62002 1.8 8.33002 2.18 8.33002 2.57C8.33002 2.96 8.71002 3.34 9.10002 3.34H9.29002V10.45H8.14002C6.60002 10.45 5.45002 11.7 5.45002 13.14V16.76L11.76 10.45V10.44Z"
				fill="currentColor"
			/>
			<path
				d="M15.92 10.45L23.01 3.36L21.98 2.33L14.66 9.65V9.62L11.17 13.11H11.2L9.94002 14.37H9.91002L5.47002 18.81C5.47002 18.81 5.47002 18.83 5.47002 18.84L2.02002 22.29L3.05002 23.32L6.13002 20.24C6.56002 20.71 7.16002 21.02 7.84002 21.12V21.7C7.84002 22.18 8.22002 22.47 8.61002 22.47H9.09002C9.57002 22.47 9.86002 22.09 9.86002 21.7V21.12H14.09V21.7C14.09 22.18 14.47 22.47 14.86 22.47H15.34C15.82 22.47 16.11 22.09 16.11 21.7V21.12C17.45 20.93 18.51 19.78 18.51 18.43V13.15C18.51 11.65 17.32 10.52 15.92 10.46V10.45ZM14.42 14.36H13.54V15.44C13.54 15.74 13.3 15.98 13 15.98C12.7 15.98 12.46 15.74 12.46 15.44V14.36H12.01L13.27 13.1H14.42C14.77 13.1 15.05 13.38 15.05 13.73C15.05 14.08 14.77 14.36 14.42 14.36Z"
				fill="currentColor"
			/>
		</svg>
	);
}

BaggageMDisabledFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default BaggageMDisabledFilledIcon;
